import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';


const LoadingSpinner = ({
    fontSize = 12,
    color="blue"
}) => <Spin indicator={<LoadingOutlined style={{ 
    fontSize: fontSize,
    color: color
}} spin />} />;

export default LoadingSpinner;